import Vue from 'vue';
let month = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
Vue.filter('month', function (val) {
    if (!val)return '';
    let mon = val.getMonth();
    if(mon<12&&mon>=0){
        return month[mon];
    }else{
        return '';
    }
});